import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

import errorGuy from '../../assets/images/error-guy.svg';

const isDev = process.env.NODE_ENV === 'development';

const ErrorPage = () => {
  // Use window.location for navigation to avoid dependency on Router context
  // This component may render as an errorElement outside the Router tree
  const handleGoHome = () => {
    window.location.href = '/';
  };

  const currentUrl = window.location.href;
  const pathname = window.location.pathname;
  const apiUrl = process.env.HEALIO_API_URL ?? '(not set)';
  const isApiPath =
    pathname.startsWith('/HealioAPI') ||
    pathname.startsWith('/local-api') ||
    pathname.startsWith('/api');

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', padding: '4rem 0' }}>
      <Box
        alt="Error 404 Illustration"
        component="img"
        loading="lazy"
        src={errorGuy}
        sx={{ maxWidth: '100%', margin: '2rem' }}
      />
      <Typography variant="h1" gutterBottom>
        Oops!
      </Typography>
      <Typography
        variant="body1"
        gutterBottom
        sx={{
          color: 'text.secondary',
        }}
      >
        It seems like the page you were looking for doesn&apos;t exist.
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          marginBottom: '2rem',
        }}
      >
        This might be because you have typed the web address incorrectly or the page you were
        looking for has been moved or deleted.
      </Typography>
      {isDev && (
        <Box
          sx={{
            textAlign: 'left',
            backgroundColor: 'grey.100',
            borderRadius: 1,
            p: 2,
            mb: 2,
          }}
        >
          <Typography variant="subtitle2" gutterBottom>
            Diagnostics (dev only)
          </Typography>
          <Typography variant="body2" component="div" sx={{ fontFamily: 'monospace', mb: 1 }}>
            <strong>URL:</strong> {currentUrl}
          </Typography>
          <Typography variant="body2" component="div" sx={{ fontFamily: 'monospace', mb: 1 }}>
            <strong>Path:</strong> {pathname}
          </Typography>
          <Typography variant="body2" component="div" sx={{ fontFamily: 'monospace', mb: 1 }}>
            <strong>HEALIO_API_URL:</strong> {apiUrl}
          </Typography>
          {isApiPath && (
            <Typography
              variant="body2"
              component="div"
              sx={{ fontFamily: 'monospace', color: 'error.main', mt: 1 }}
            >
              This looks like an API path. The IIS URL rewrite or httpErrors section in web.config
              may be routing API requests to index.html instead of letting them pass through to the
              API application. Check that the web.config rewrite rules exclude this path, and that
              the httpErrors section is not replacing 404 responses for API routes.
              {pathname.startsWith('/HealioAPI') && (
                <>
                  {' '}
                  If the API is running, try{' '}
                  <a href="/HealioAPI/swagger" style={{ color: 'inherit' }}>
                    /HealioAPI/swagger
                  </a>{' '}
                  to access the Swagger UI.
                </>
              )}
            </Typography>
          )}
        </Box>
      )}
      <Button variant="contained" color="primary" onClick={handleGoHome}>
        Go Back Home
      </Button>
    </Container>
  );
};

export default ErrorPage;
